import { CarFormValues, HomeFormValues } from 'interfaces/property'
import { ManualAccountFormData } from 'interfaces/linkage'
import { FormNameType } from 'interfaces/form'

export const ZIP_CODE_MASK = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
export const DATE_MASK = [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/]
export const TELEPHONE_MASK = ['(', /[0-9]/, /[0-9]/, /[0-9]/, ')', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]

// FORM NAMES
// --------------------------------------------------------------------------
export const FORM_ONBOARDING_REGISTER = 'onboarding-register' as const
export const FORM_ONBOARDING_PROPERTY = 'onboarding-property' as const
export const FORM_SETTINGS_CREDIT = 'credit-linkage' as const
export const FORM_SETTINGS_CREDIT_EXTENDED = 'credit-linkage-extended' as const
export const FORM_MANUAL_ACCOUNT = 'manual-account' as const

export const FORM_LINKAGE_AUTHENTICATION = 'linkage-authentication' as const
export const FORM_PROVIDER_SEARCH = 'provider-search' as const
export const FORM_PROVIDER_SEARCH_FIELD = 'search' as const
export const FORM_LOGIN = 'login' as const
export const FORM_DEVICE_VERIFICATION = 'device-verification' as const
export const FORM_PASSWORD_CODE_SEND = 'password-code-send' as const
export const FORM_PASSWORD_RESET = 'password-reset' as const
export const FORM_PASSWORD_CHANGE = 'password-change' as const
export const FORM_HOMES_EDIT = 'homes-edit' as const
export const FORM_CARS_EDIT = 'cars-edit' as const
export const FORM_MEMBER_PROFILE = 'member-profile' as const
export const FORM_CONTACT_EDIT = 'contact-edit' as const
export const FORM_REDEMPTION = 'redemption' as const

export const FORM_CREATE_CUSTOM_PEER_GROUP = 'create-custom-peer-group' as const
export const FORM_EDIT_CUSTOM_PEER_GROUP = 'edit-custom-peer-group' as const

export const FORM_CREATE_SPENDING_TRACKER = 'create-spending-tracker' as const
export const FORM_CREATE_INCOME_TRACKER = 'create-income-tracker' as const

export const FORM_EDIT_SPENDING_TRANSACTION = 'edit-spending-transaction' as const
export const FORM_EDIT_INCOME_TRANSACTION = 'edit-income-transaction' as const
export const FORM_EDIT_TRANSACTIONS_TRANSACTION = 'edit-transactions-transaction' as const
export const FORM_RECAT_TRANSACTION = 'recat-transaction' as const
export const FORM_SIMILAR_TRANSACTIONS = 'similar-transactions' as const

export const FORM_SOCIAL_PROFILE = 'social-profile' as const
export const FORM_USER_SEARCH = 'feed-user-search' as const
export const FORM_TAG_SEARCH = 'tag-search' as const

export const FORMS_WITH_PASSWORD: FormNameType[] = [FORM_PASSWORD_CHANGE, FORM_ONBOARDING_REGISTER, FORM_PASSWORD_RESET]

// ===========================================================================//
//                                   HOMES                                    //
// ===========================================================================//
export const HOME_FORM_INITIAL_VALUES: HomeFormValues = {
  address1: '',
  address2: '',
  zip5: '',
  is_primary_residence: false,
  estimated_value: null,
  city: null,
  purchased_at: null,
}


// ===========================================================================//
//                                   CARS                                     //
// ===========================================================================//
export const CAR_FORM_INITIAL_VALUES: CarFormValues = {
  make: null,
  model: null,
  year: null,
  estimated_value: null,
  purchased_at: null,
}

export const CURRENCY_OPTIONAL_DECIMALS_FORMAT = '0[.]00'
export const CURRENCY_WITH_DECIMALS_FORMAT = '0.00'

// ===========================================================================//
//                                   REST                                     //
// ===========================================================================//

export const POLICY_CHECKBOX_NAME = 'policy'

export const MANUAL_ACCOUNT_FORM_INITIAL_VALUES: ManualAccountFormData = {
  name: '',
  amount: {
    sign: 1,
    absValue: null,
  },
  category: null,
}
